import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { App } from './App';
import './index.css';
import './polyfills';
import { errorHandler } from './lib/error-handling';

// Initialize browser configuration when env-config package is ready

// Initialize global error handling
errorHandler.initialize();

// Report any stored errors on startup
if (import.meta.env.PROD) {
  errorHandler.reportErrors();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
